<div
  [attr.data-test]="dataTest()"
  [attr.title]="ariaTitle() | translate"
  [attr.ngbAutofocus]="hasAutoFocus() ? true : null"
  (click)="cardClicked.emit()"
  (keydown.enter)="cardClicked.emit()"
  class="card-basic card-clickable h-100 p-0"
  tabindex="0"
>
  <div class="card-basic-body">
    <div class="row h-100 g-2">
      <div class="col">
        <div class="mb-1">
          <mwe-product-icons [categories]="categories()" [size]="'xl'" />
        </div>
        <ng-content />
      </div>
      <div class="col-auto align-self-center">
        <i class="fas fa-chevron-right text-body"></i>
      </div>
    </div>
  </div>
</div>
